import { i18n } from "@/boot/i18n";
import { REQUIRED } from "../validator/methods";

export const validators = () => {
  return {
    name: {
      field: "name",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }],
      meta: { custom: false }
    },
    offset: {
      field: "primary_time_offset",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }],
      meta: { custom: false }
    },
    language: {
      field: "primary_language",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }],
      meta: { custom: false }
    },
    code: {
      field: "country_code",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }],
      meta: { custom: false }
    },
    phone: {
      field: "phone",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }],
      meta: { custom: false }
    }
  };
};
